// export const USER_LOGGED_IN = 'USER_LOGGED_IN';

export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';

export const USER_LOGGED_IN_BY_GOOGLE = "USER_LOGGED_IN_BY_GOOGLE";

export const USER_PROFILE_UPDATED = "USER_PROFILE_UPDATED";
